import { format } from "date-fns";

export enum CapitalizationType {
  full = "full",
  standard = "standard"
}

export default class Formatter {
  public static getFormattedNumber(value: string | number) {
    const valueToFormat = this.stringToNumber(String(value));
    const returnValue = Formatter.formatDecimalPlaces(valueToFormat)
      .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      .replace(".", ",");
    return returnValue !== "0" ? returnValue : "";
  }

  private static formatDecimalPlaces(value: number) {
    const res = value.toString().split(".");

    return (res.length !== 1 && res[1].length < 2)
      ? value.toFixed(2)
      : value.toString();
  }

  public static stringToNumber(strValue: string): number {
    if (!strValue) {
      return 0;
    }
    const formattedNumber = Number(strValue.replace(/[^0-9\\.]/g, ""));
    return Math.round((formattedNumber + Number.EPSILON) * 100) / 100;
  }

  public static stringToNumberOrEmpty(strValue: string) {
    if (!strValue) {
      return "";
    }
    const returnValue = Number(strValue.replace(/[^0-9]/g, ""));
    return returnValue !== 0 ? returnValue : "";
  }

  public static removeNonPhoneCharacters(strValue: string) {
    if (!strValue) {
      return "";
    }
    return strValue.replace(/[^\d+-\s]/g, "");
  }

  public static convertNormalToCentsNumber(price: number): number {
    return price * 100;
  }

  public static convertNormalToCentsString(price: number): string {
    return this.convertNormalToCentsNumber(price).toString();
  }

  public static convertCentsToNormalNumber(price: number | string): number {
    if (!price) {
      return 0;
    }
    const floatPrice = typeof price === "string" ? parseFloat(price) : price;
    return floatPrice / 100;
  }

  public static convertCentsToNormalString(price: number | string): string {
    return this.convertCentsToNormalNumber(price).toString();
  }

  public static decimalPriceFormat(price: number | string): string {
    if (!price) {
      return "0,00";
    }

    const priceAsNumber = typeof price === "string" ? parseFloat(price) : price;
    return `${priceAsNumber.toFixed(2).replace(".", ",")}`;
  }

  public static getStringDate(date: any) {
    return format(date, "yyyy-MM-dd");
  }


  public static capitalizeWords(value: any, type: CapitalizationType | undefined) {
    if (!value || !type) {
      return value;
    }

    switch (type) {
      case CapitalizationType.full:
        return this.fullUpperCase(value);
      case CapitalizationType.standard:
        return this.standard(value);
      default:
        return value;
    }
  }

  private static fullUpperCase(value: any) {
    if (typeof value === "string") {
      return value.toUpperCase();
    }
    return value;
  }

  private static standard(value: any) {
    return value;
  }
}
